export const demoTourCSS = `
  .driver-popover {
    background: rgba(15, 18, 25, 0.95) !important;
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(0, 242, 255, 0.25) !important;
    border-radius: 14px !important;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5), 0 0 30px rgba(0, 242, 255, 0.08) !important;
    color: #f8fafc !important;
    max-width: 320px !important;
    font-family: 'Outfit', sans-serif !important;
  }

  .driver-popover * {
    font-family: 'Outfit', sans-serif !important;
  }

  .driver-popover-title {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #00f2ff !important;
    font-family: 'Space Grotesk', 'Outfit', sans-serif !important;
    margin-bottom: 6px !important;
  }

  .driver-popover-description {
    font-size: 13px !important;
    line-height: 1.5 !important;
    color: #94a3b8 !important;
  }

  .driver-popover-progress-text {
    font-size: 12px !important;
    color: #64748b !important;
  }

  .driver-popover-navigation-btns {
    gap: 8px !important;
  }

  .driver-popover-prev-btn {
    background: rgba(255, 255, 255, 0.06) !important;
    border: 1px solid rgba(255, 255, 255, 0.12) !important;
    color: #94a3b8 !important;
    border-radius: 8px !important;
    padding: 6px 16px !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    text-shadow: none !important;
    transition: all 0.2s ease !important;
  }

  .driver-popover-prev-btn:hover {
    background: rgba(255, 255, 255, 0.1) !important;
    color: #f8fafc !important;
  }

  .driver-popover-next-btn,
  .driver-popover-close-btn-text {
    background: #00f2ff !important;
    color: #080a0f !important;
    border: none !important;
    border-radius: 8px !important;
    padding: 6px 16px !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    text-shadow: none !important;
    transition: all 0.2s ease !important;
  }

  .driver-popover-next-btn:hover,
  .driver-popover-close-btn-text:hover {
    background: #33f5ff !important;
    box-shadow: 0 0 16px rgba(0, 242, 255, 0.3) !important;
  }

  .driver-popover-arrow-side-left .driver-popover-arrow,
  .driver-popover-arrow-side-right .driver-popover-arrow,
  .driver-popover-arrow-side-top .driver-popover-arrow,
  .driver-popover-arrow-side-bottom .driver-popover-arrow {
    border-color: rgba(15, 18, 25, 0.95) !important;
  }

  .driver-overlay {
    background: rgba(0, 0, 0, 0.3) !important;
  }

  .driver-active-element {
    box-shadow: 0 0 0 4px rgba(0, 242, 255, 0.3), 0 0 20px rgba(0, 242, 255, 0.15) !important;
    border-radius: 8px !important;
  }

  .driver-popover-footer {
    border-top: 1px solid rgba(255, 255, 255, 0.06) !important;
    margin-top: 12px !important;
    padding-top: 12px !important;
  }

  .driver-popover-close-btn {
    color: #64748b !important;
  }

  .driver-popover-close-btn:hover {
    color: #f8fafc !important;
  }
`
